export const INITIAL_DYNAMIC_ATTRIBUTES = Object.freeze({
  fields: {
    displayCoverPicture: true,
    displayTitle: true,
    displayCategories: true,
    displayDate: true,
    displayLocation: true,
    displayAttendees: true,
    displayOnlineEvent: true,
    displayContent: true,
  },
  fontFamily: 'Arial',
  itemId: null,
  query: {
    dataType: 'last_published',
  },
  _selectedItem: {
    label: null,
    value: null,
  },
  singleLine: true,
  type: 'empty',
});
